import styled from "styled-components";
import Select from "react-select";
import type { StylesConfig, DropdownIndicatorProps } from "react-select";
import { ComponentProps } from "react";

const customStyles: StylesConfig = {
	container: provided => ({
		...provided,
		width: "100%",
		maxWidth: "100%",
	}),
	control: (provided, state) => ({
		...provided,
		height: "50px",
		backgroundColor: "#FFFFFF",
		borderRadius: "8px",
		border: "2px solid #d8dbe4 !important",
		boxShadow: "none",
		outline: state.isFocused ? "2px solid #000000" : "none",
		outlineOffset: "-2px",
		opacity: state.isDisabled ? 0.5 : 1,
	}),
	indicatorSeparator: () => ({
		display: "none",
	}),
	valueContainer: provided => ({
		...provided,
		fontFamily: "Livvic",
		fontStyle: "normal",
		fontWeight: 500,
		fontSize: "14px",
		lineHeight: "165.5%",
		paddingLeft: "15px",
		textAlign: "left",
	}),
	singleValue: provided => ({
		...provided,
		color: "#000000",
	}),
	placeholder: provided => ({
		...provided,
		color: "#959AAB",
	}),
	menu: provided => ({
		...provided,
		zIndex: 5,
		border: "1px solid #d8dbe4",
		borderRadius: "8px",
		marginTop: "4px",
		overflow: "hidden",
	}),
	menuList: provided => ({
		...provided,
		padding: "0px",
	}),
	option: (provided, state) => ({
		...provided,
		fontFamily: "Livvic",
		fontStyle: "normal",
		fontWeight: 500,
		fontSize: "14px",
		backgroundColor: state.isSelected ? "#e5e5e5" : "#FFFFFF",
		color: "#000000",
		padding: "12px 16px",
		textAlign: "left",
		"&:active": {
			backgroundColor: "#e5e5e5",
		},
		"&:not(:last-child)": {
			borderBottom: "1px solid #d8dbe4",
		},
	}),
};

const ArrowContainer = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 16px 0 8px;
`;

const Arrow = ({ selectProps }: DropdownIndicatorProps) => {
	return (
		<ArrowContainer>
			<svg
				style={{
					transition: "all .25s",
					transform: selectProps.menuIsOpen ? "rotate(0.5turn)" : "rotate(0)",
				}}
				width="16"
				height="16"
				viewBox="0 0 11 6"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.242793 0.21967C0.566517 -0.0732233 1.09138 -0.0732233 1.4151 0.21967L5.25 3.68934L9.0849 0.21967C9.40862 -0.0732233 9.93348 -0.0732233 10.2572 0.21967C10.5809 0.512563 10.5809 0.987437 10.2572 1.28033L5.83615 5.28033C5.51243 5.57322 4.98757 5.57322 4.66385 5.28033L0.242793 1.28033C-0.080931 0.987437 -0.080931 0.512563 0.242793 0.21967Z"
					fill="#000000"
				/>
			</svg>
		</ArrowContainer>
	);
};

type SelectFieldProps = ComponentProps<typeof Select> & {
	disabled?: boolean;
	errorMode?: boolean;
};

export type OptionType = {
	label: string;
	value: string;
};

const SelectField = ({ ...props }: SelectFieldProps) => {
	return (
		<Select
			{...props}
			styles={customStyles}
			noOptionsMessage={() => "Não há opções"}
			components={{
				DropdownIndicator: Arrow,
			}}
		/>
	);
};

export default SelectField;
